import amplitude from 'tools/amplitude/amplitude';

import {
  LogSFMainBtnParams,
  LogEventClickOutOfStockBtn,
  LogEventSendOutOfStockItems,
  LogSFSendStockoutsParams,
  LogEventCancelOrder,
  LogSFCancelOrderParams,
} from './substitutionFlow.analytic.model';

export function logAnalyticSFMainBtn(params: LogSFMainBtnParams) {
  const { partnerId, storeId, orderId, orderStatus } = params;
  const data: LogEventClickOutOfStockBtn = {
    PARTNER_ID: partnerId,
    STORE_ID: storeId,
    ORDER_ID: orderId,
    OPENED_BY: orderStatus === 'cooking' ? 'post-take' : 'pre-take',
  };
  amplitude.logEvent('CLICK_OUT_OF_STOCK_BUTTON', data);
}

export function logAnalyticSFSendStockouts(params: LogSFSendStockoutsParams) {
  const { partnerId, order, itemsOutStock, flow, fromChatBtn } = params;
  const data: LogEventSendOutOfStockItems = {
    PARTNER_ID: partnerId,
    STORE_ID: order.products[0].storeId,
    ORDER_ID: order.id,
    PRODUCT_IDS: itemsOutStock.products.map(p => p.id),
    CUSTOMIZATION_IDS: itemsOutStock.toppings.map(t => t.detail.id),
    FLOW: flow,
    FLOW_INITIATED_BY: fromChatBtn
      ? 'chat_button'
      : 'select_out_of_stock_button',
  };
  amplitude.logEvent('SEND_OUT_OF_STOCK_ITEMS', data);
}

export function logAnalyticSFCancelOrder(params: LogSFCancelOrderParams) {
  const { SFState } = params;
  const data: LogEventCancelOrder = {
    PARTNER_ID: SFState.partnerId,
    STORE_ID: SFState.storeId,
    ORDER_ID: SFState.orderId,
  };
  amplitude.logEvent('CANCEL_ORDER_SUBSTITUTION_FLOW', data);
}

export const substitutionFlowAnalytics = {
  logMainBtn: logAnalyticSFMainBtn,
  logSendOutOfStockItems: logAnalyticSFSendStockouts,
  logCancelOrder: logAnalyticSFCancelOrder,
} as const;
